import store from "@/lib/store/store";
import Parse from 'parse/dist/parse.min.js';

const state = {
	data: [],
	focusedEntryLinkId: undefined,
	loaded: false,
};

const getters = {
	getEntryLinks(state) {
		if (state.data) {
			return state.data;
		}
		return undefined;
	},
	areEntryLinksLoaded(state) {
		return state.data && state.data.length > 0;
	},
	getFilteredEntryLinks(state) {
		if (state.data.length > 0) {
			return state.data;
		}
		return undefined;
	},
	getFocusedEntryLink(state) {
		if (state.data) {
			return state.data.find(entryLink => entryLink.id === state.focusedEntryLinkId)
		}
		return undefined;
	},
	getFocusedEntry(state, getters, rootState, rootGetters) {
		return rootState.focusedEntry
	},
	getLoaded(state) {
		return state.loaded
	}
};

// LiveQuery events carry a bare EntryLink; refetch it with the full
// include tree and drop rows the current user may not see (private
// links of other authors). Runs in the actions so the mutations stay
// synchronous.
const fetchVisibleEntryLink = async (objectId) => {
	let user_id = store.getters["users/getUserId"];
	let entryLinkQuery = new Parse.Query('EntryLink');
	entryLinkQuery.equalTo("objectId", objectId);
	entryLinkQuery.include(["entry", "entry.author.dependency", "entry.otherFiles", "client", "client.group", "entry.attributes", "entry.attributes.attribute_config"]);
	const res = await entryLinkQuery.find();
	if(res.length == 0) return undefined;
	if(!res[0].attributes.isPrivate || res[0].attributes.isPrivate === false || (res[0].attributes.isPrivate === true && res[0].attributes.author.id == user_id))
	{
		return res[0];
	}
	return undefined;
};

const mutations = {
	SET(state, objects) {
		state.data = objects
	},
	INSERT(state, object) {
		const oldObject = state.data.filter(item => item.id == object.id)
		const index = state.data.indexOf(oldObject[0]);
		if (index == -1) {
			state.data.unshift(object);
		}
	},
	DELETE(state, object) {
		state.data = state.data.filter((elem) => {
			return elem.id != object.id
		})
	},
	REPLACE(state, object) {
		const oldObject = state.data.filter(item => item.id == object.id)
		const index = state.data.indexOf(oldObject[0]);
		if (index > -1) {
			state.data.splice(index, 1, object);
		}
	},
	SET_FOCUSED_ENTRY_LINK_ID(state, data) {
		state.focusedEntryLinkId = data
	},
	LOAD(state, load) {
		state.loaded = load
	},
};

const actions = {
	set({ commit }, objects) {
		const entryLinks = objects;
		commit('SET', entryLinks)
	},
	async insert({ commit }, object) {
		const entryLink = await fetchVisibleEntryLink(object.id);
		if (entryLink) commit('INSERT', entryLink)
	},
	delete({ commit }, object) {
		commit('DELETE', object)
	},
	async replace({ commit }, object) {
		const entryLink = await fetchVisibleEntryLink(object.id);
		if (entryLink) commit('REPLACE', entryLink)
	},
	setFocusedEntryLinkId({ commit }, query) {
		commit("SET_FOCUSED_ENTRY_LINK_ID", query)
	},
	load({ commit }, object) {
		commit('LOAD', object)
	},
};

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations
};
